import axios from '@/utils/axios';
const prefix = 'activity/wxapp/signin/'; //会员签到前缀
const signInApi = {
  signIn: {
    // getUserInfo: params => service.get('/index/getUserInfo', { params }),
    getSigninQuery: (data?: any) => axios.post(prefix + 'query', data), //查询签到信息
    queryDesc: (data?: any) => axios.post(prefix + 'queryDesc', data), //查询说明
    queryFragment: (data?: any) => axios.post(prefix + 'queryFragment', data), //查询碎片
    queryFragmentDetail: (data?: any) =>
      axios.post(prefix + 'queryFragmentDetail', data), //碎片明细
    querySite: (data?: any) => axios.post(prefix + 'querySite', data), //查询碎片兑换地址
    querySwitch: (data?: any) => axios.post(prefix + 'querySwitch', data), //查询签到提醒开关
    signin: (data?: any) => axios.post(prefix + 'signin', data), //签到
    switchSignin: (data?: any) => axios.post(prefix + 'switch', data), //签到提醒开关
    queryFragmentAccumulate: (data?: any) =>
      axios.post(prefix + 'queryFragmentAccumulate', data), //查询碎片积累量
  },
};
export default signInApi;
